<template>
  <div class="card-product">
    <transition
    enter-active-class="animate__animated animate__fadeIn"
    leave-active-class="animate__animated animate__fadeOut">
      <div class="card-product-content" v-if="Object.keys(product).length">
        <div class="product-media" :class="{ 'show-full': product.related_product &&  product.related_product.length === 0 }">
          <no-ssr>
            <overlay-scrollbars class="product-media_wrapper-scrollable">
              <div class="product-media_media"  v-for="(image, index) in allImageProduct" :key="index">
                <image-gallery
                :imgPath="image.urlResize"
                :alt="image.label"
                :hasVideo="(image && image.video_content) ? image.video_content.video_url : ''"
                :changeAble="true"/>
              </div>
            </overlay-scrollbars>
          </no-ssr>
        </div>
        <div class="product-info">
          <div class="product-info__title">
            <div class="product-name">
              <p class="title" v-html="product && product.name" />
            </div>
          </div>
          <div class="product-info__price">
            <product-price :product="productSelected" />
            <p class="vat-included" v-html="vatRules"></p>
          </div>
          <div class="selections" v-if="configurable_options.length">
            <product-options
              :product="product"
              :filterActive="filterActive"
              :variants="configurable_options"
              :defaultSelection="defaultSelection"
              @siblingChange="siblingChange"
              @changeFilter="variantChange"
            ></product-options>
          </div>
          <!--div class="product-info__find-in-boutique">
            <find-in-boutique
            :product="product"
            :configurableOptions="configurable_options"
            :filterActive="filterActive"
            @storeChange="storeChange" />
          </div-->
          <div class="product-info__descriptions">
            <accordion-tabs :product="product" :variantSelected="productSelected" />
          </div>
        </div>
        <manage-quantity :minQty="1" :maxQty="quantityAvailable" :incrementStep="qtyIncremental" :currentQty.sync="requestedQty" v-if="!notifyProcess" ref="updateQty">
          <template slot="apply">
            <add-to-cart
            :sku="product.sku || ''"
            :append="false"
            :enableAdd="canAddTo"
            :product="product"
            :variant="getVariantsSelected"
            :qty="requestedQty"
            :disabled="quantityAvailable <= 0"
            buttonText="ok"
            @loading="cartLoading"
            @cannotAdd="showErrors"
            @success="addedToCart"
            />
            <div class="quantity-successfully-added">
              <span class="current-qty">+{{requestedQty}}</span>
              <button class="btn btn-icon btn-icon-no-border added-to-cart">
                <svg class="o-icon fill-white"><use xlink:href="#check"></use></svg>
              </button>
            </div>
            <absolute-loader :showLoader="cartLoader"></absolute-loader>
          </template>
        </manage-quantity>
      </div>
    </transition>
    <related-product :relatedProduct="product.related_product" @productClicked="siblingChange"></related-product>
    <absolute-loader :showLoader="showLoader" mode="fixed"></absolute-loader>
  </div>
</template>

<script>
import ImageGallery from 'theme/components/Product/Image'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import AddToCart from 'theme/components/AddToCart'
import ProductPrice from 'theme/components/Listing/ProductPrice'
import ProductOptions from 'theme/components/Product/ProductOptions'
import NotifyMe from 'theme/components/Product/NotifyMe/NotifyMe'
import AccordionTabs from 'theme/components/Accordion/AccordionTab'
import ManageQuantity from 'theme/components/ManageQuantity/ManageQuantity'
import FindInBoutique from 'theme/components/Product/FindInBoutique'
import { toast } from 'theme/modules/notifications'
import { EventBus } from '@/helpers'
import filter from 'lodash/filter'
import find from 'lodash/find'
import map from 'lodash/map'
import RelatedProduct from 'theme/components/Product/Related/RelatedProduct'
import Config from 'config'

export default {
  name: 'QuickClassicProduct',
  props: {
    productUrlKey: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      cartLoader: false,
      showLoader: false,
      product: {},
      notifyProcess: false,
      headerHeight: 0,
      currentSlideImage: 0,
      requestedQty: 1,
      defaultSelection: {},
      filterActive: {}
    }
  },
  computed: {
    vatRules () {
      let content = this.$store.getters['cms/getContent'](Config.Theme.blockTaxRuleID)
      content = content.replace('{taxRate}', `${this.product.tax_rate}%`)
      return content
    },
    configurable_options () {
      return this.product ? this.product.configurable_options || [] : []
    },
    qtyIncremental () {
      if (this.product && this.product.qty_increment) {
        return this.product.qty_increment
      } else {
        return 1
      }
    },
    configurableOptionsMap () {
      let map = {}
      this.configurable_options.forEach(confOpt => {
        map[confOpt.attribute_code] = confOpt
      })
      return map
    },
    getVariantsSelected () {
      if (this.configurable_options.length === Object.keys(this.filterActive).length) {
        return { ...this.filterActive }
      } else {
        return null
      }
    },
    isOnlineMode () {
      return this.$store.getters['userAdmin/getOnlineMode']
    },
    canAddTo () {
      return this.getVariantsSelected != null
    },
    quantityAvailable () {
      if (this.productSelected.length > 1) {
        return this.product.quantity
      } else {
        let stockOnCart = this.$store.getters['cart/stockOnCart'](this.productSelected.sku)
        return this.productSelected.quantity - stockOnCart
      }
    },
    productSelected () {
      const _this = this
      // loop variant of product with every filter active
      let product = this.product

      if (this.product.variants) {
        let variants = this.product.variants
        for (let i in this.filterActive) {
          variants = filter(variants, function (variant) {
            let attr = find(variant.attributes, function (attibute) {
              if (attibute.value_index === _this.filterActive[i]) return true
              return false
            })
            return attr
          })
        }
        if (variants.length) {
          product = map(variants, 'product')
        }
      }
      return product
    },
    allImageProduct () {
      // push all product image
      // let images = this.product.media_gallery ? this.product.media_gallery.concat(this.product.image) : []
      let images = this.product.media_gallery || []
      return images
    },
    productMedia () {
      // push all product image
      let media = [...this.allImageProduct]
      let firstVariant = this.productSelected.length ? { ...this.productSelected[0] } : { ...this.product }
      if (firstVariant && firstVariant.media_gallery) {
        let video = find(firstVariant.media_gallery, 'video_content')
        video && media.push(video)
      }
      return media
    }
  },
  methods: {
    modalScrollTo (to = 0) {
      $('#quick-modal .modal-body').animate({
        scrollTop: to
      }, 300)
    },
    siblingChange ($event) {
      this.modalScrollTo()
      const urlKey = $event.url_key + $event.url_suffix
      this.initProduct({ urlKey })
    },
    cartLoading (boolVal) {
      this.cartLoader = boolVal
    },
    variantChange (variant) {
      if (variant.value) {
        this.$set(this.filterActive, variant.type, variant.value)
      } else {
        this.$delete(this.filterActive, variant.type)
      }
      if (variant.isNotificable) {
        this.notifyProcess = true
      } else {
        this.notifyProcess = false
      }
      this.emptyQty()
    },
    showErrors ($event) {
      // Show size error
      // the error message in inside component
      // use event bus to reach it
      if ($event) {
        const $anchor = $('.card-product .selections')
        this.modalScrollTo($anchor.offset().top)
      }
      EventBus.$emit('cart:sizeError', $event)
    },
    addedToCart ($event) {
      // Add class to manage qty for a 2000ms
      // as explained in https://drive.google.com/file/d/1NKJ-YuqwHA5V49C-bOc9L6e0eOxxh_iE/view?usp=sharing
      const $qtyRef = this.$refs.updateQty.$el
      $qtyRef.classList.add('quantity-added')
      setTimeout(() => {
        $qtyRef.classList.remove('quantity-added')
      }, 2000)
      // this event close modal
      // on 22.04.21 commented by designer request
      // this.$emit('added-to-cart', $event)
    },
    initProduct ({ urlKey }) {
      const _this = this
      this.showLoader = true
      return this.$store.dispatch('quickBuy/openQuickBuy', { url_key: urlKey })
        .then((product) => {
          // reinit qty
          _this.emptyQty()
          _this.product = product
          _this.selectUniqueSize()
        }).catch((err) => {
          if (err.message) {
            toast.error(_this.$t(err.message))
          } else {
            toast.error(_this.$t('GenericError'))
          }
        }).finally(() => {
          _this.showLoader = false
        })
    },
    emptyQty () {
      this.requestedQty = this.qtyIncremental
      return this.requestedQty
    },
    notifyModal (toggle) {
      if (toggle) {
        const _this = this
        const componentToLoad = import('theme/components/Product/NotifyMe/NotifyMe')
        this.$store.dispatch('ui/loadGenericModalComponent', {
          component: componentToLoad,
          props: {
            product: _this.product,
            productSelected: _this.productSelected,
            variant: _this.getVariantsSelected
          },
          modalProps: {
            hideFooter: true
          }
        })
      }
    },
    storeChange ($event) {
      this.showLoader = $event
      // after this event start logic to change store
      // after change store initProduct will be called
      // initProduct at the end hide loader
    },
    selectUniqueSize () {
      // if size is only 1 active it
      let configurableOptionBySize = find(this.product.configurable_options, { attribute_code: 'size' })
      if (configurableOptionBySize && configurableOptionBySize.values.length) {
        this.defaultSelection[configurableOptionBySize.attribute_id] = this.product.sku
      }
      return true
    }
  },
  mounted () {
    if (process.client) {
      if (this.productUrlKey.length) {
        this.initProduct({ urlKey: this.productUrlKey })
      }
      EventBus.$on('quickView:initProduct', this.initProduct)
    }
    return this.$store.dispatch('cms/loadContent', Config.Theme.blockTaxRuleID)
  },
  destroyed () {
    EventBus.$off('quickView:initProduct', this.initProduct)
    global.productClickListener = false
  },
  components: {
    RelatedProduct,
    ImageGallery,
    ProductPrice,
    AbsoluteLoader,
    ProductOptions,
    AccordionTabs,
    NotifyMe,
    ManageQuantity,
    AddToCart,
    FindInBoutique
  }
}
</script>
